function redirectOverride(cartItems,discountCode) {
  let cartRedirect = '/cart';
  if (window.location.href.indexOf('https://tokidos.com/fr/')>-1) {
    cartRedirect = '/fr/cart';
  }

  const localStorageKey = 'tokidosQuiz_';
  const localStorageObjects = Object.keys(localStorage).filter( (key)=> key.startsWith(localStorageKey) ).map( (key)=> localStorage[key] );
  const localStorageQuizKeys = Object.keys(localStorage).filter( (key)=> key.startsWith(localStorageKey) );
  let cartAddItems = [];
  for (let i=0; i < localStorageObjects.length; i++) {
    let quizData = JSON.parse(localStorageObjects[i]);
    if (quizData && quizData.includes_playcubes && quizData.includes_playcubes.value && quizData.playcube_variant_id && quizData.playcube_variant_id.value) {
      let item = {
        id: quizData.playcube_variant_id.value,
        quantity: 1
      }
      if (quizData.playcubes_message_property) {
        item.properties = { [quizData.playcubes_message_property.value] : quizData.playcubes_message.value.replace(/&#39;/g, '"') || '' }
      }
      cartAddItems.push(item);
    }
  }

  console.log('cart add items', cartAddItems);

  if (cartAddItems.length > 0) {
    //fetch to cart/add.js to add the playcubes, then redirect to /cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: cartAddItems
      })
    })
    .then(response => {
      if (response.ok) {
        //remove localstorage items
        //localStorageQuizKeys.forEach(key => {
        //  localStorage.removeItem(key);
        //});
        window.location.href = cartRedirect;
      } else {
        console.error('Failed to add items to cart');
      }
    });
  }
  else {
    //remove localstorage items
    //localStorageQuizKeys.forEach(key => {
    //  localStorage.removeItem(key);
    //});
    window.location.href = cartRedirect;
  }
}

window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
    addToCartRedirect: redirectOverride
  }
});
